import React from 'react';
import { Heart, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B1120] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Mission */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_6b3489be-920b-4f06-be49-83f9903cfac6/artifacts/sacmjjq6_image.png"
                alt="The Prestigious Travel Club Foundation"
                className="h-14 w-auto rounded-lg"
              />
            </div>
            <p className="text-slate-400 font-light leading-relaxed mb-6">
              A 501(c)(3) nonprofit organization dedicated to making a meaningful difference 
              in communities through feeding programs, veteran support, children's healthcare, 
              and mentorship initiatives.
            </p>
            <p className="text-sm text-slate-500">
              All donations are tax-deductible.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4 font-serif">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { href: '/#mission', label: 'Our Mission' },
                { href: '/#impact', label: 'Our Impact' },
                { href: '/#partners', label: 'Our Partners' },
                { href: '/#about', label: 'About Us' },
              ].map((link) => (
                <li key={link.href}>
                  <a 
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs & Contact */}
          <div>
            <h4 className="font-semibold text-white mb-4 font-serif">Programs</h4>
            <ul className="space-y-3 text-slate-400 mb-8">
              <li><a href="/mentoring" className="hover:text-white transition-colors">Mentoring Program</a></li>
              <li><a href="/financial-education" className="hover:text-white transition-colors">Financial Education</a></li>
              <li><a href="/housing" className="hover:text-white transition-colors">Housing Project</a></li>
            </ul>
            <h4 className="font-semibold text-white mb-4 font-serif">Contact</h4>
            <a 
              href="mailto:Info@prestigioustravelclub.org" 
              className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
            >
              <Mail className="w-4 h-4" />
              Info@prestigioustravelclub.org
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © {currentYear} The Prestigious Travel Club Foundation. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-slate-500">
            <a href="/privacy-policy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</a>
            <span className="text-slate-700">|</span>
            <a href="/terms-and-conditions" className="hover:text-white transition-colors" data-testid="footer-terms-link">Terms & Conditions</a>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-red-500 fill-red-500" />
            <span>for communities in need</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
